import React from 'react';
import FloatingMenu from '../FloatingMenu';
import projectVideo from '../../assets/videos/project1.mp4';
import langraphImage from '../../assets/images/gallery/langraph.svg';
import uiImage from '../../assets/images/gallery/ui.png';

const Gallery = () => (
  <div className="page-section">
    <FloatingMenu />
    <h1>Gallery</h1>
    
    {/* Featured Project Video */}
    <div style={{marginBottom:'3rem',maxWidth:'960px',margin:'0 auto'}}>
      <h2 style={{color:'#e0aaff',marginBottom:'1rem'}}>Kitchen Assistant AI Project Overview</h2>
      <div style={{background:'#fff2',borderRadius:'1rem',padding:'1.5rem',marginBottom:'1rem'}}>
        <div style={{maxWidth:'800px', margin:'0 auto', position:'relative'}}>
          <video 
            id="kitchenAssistantVideo"
            controls 
            width="100%"
            height="auto"
            poster="/assets/images/logo.png"
            style={{
              borderRadius:'0.5rem',
              boxShadow:'0 4px 12px rgba(0,0,0,0.3)',
              maxHeight:'450px',
              objectFit:'contain'
            }}
            controlsList="nodownload"
            preload="metadata"
          >
            <source src={projectVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <button 
            onClick={() => {
              const video = document.getElementById('kitchenAssistantVideo');
              if (video.requestFullscreen) {
                video.requestFullscreen();
              } else if (video.webkitRequestFullscreen) { /* Safari */
                video.webkitRequestFullscreen();
              } else if (video.msRequestFullscreen) { /* IE11 */
                video.msRequestFullscreen();
              }
            }}
            style={{
              position:'absolute',
              bottom:'15px',
              right:'15px',
              backgroundColor:'rgba(0,0,0,0.5)',
              border:'none',
              borderRadius:'4px',
              padding:'5px',
              cursor:'pointer',
              zIndex:2,
              display:'flex',
              alignItems:'center',
              justifyContent:'center',
              width:'30px',
              height:'30px',
              color:'white'
            }}
            aria-label="Full Screen"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4H9V6H6V9H4V4Z" fill="currentColor" />
              <path d="M20 4H15V6H18V9H20V4Z" fill="currentColor" />
              <path d="M4 20H9V18H6V15H4V20Z" fill="currentColor" />
              <path d="M20 20H15V18H18V15H20V20Z" fill="currentColor" />
            </svg>
          </button>
        </div>
        <div style={{marginTop:'1rem',color:'#fff',fontSize:'1.1rem',lineHeight:'1.6'}}>
          <p>This comprehensive demonstration showcases our AI-powered Kitchen Assistant in action, combining technical insights with practical use cases. The video illustrates how our system helps users manage recipes, plan meals, and optimize kitchen workflows through intuitive AI interactions.</p>
          <p style={{marginTop:'0.5rem',color:'#e0aaff',fontWeight:'500'}}>Featuring advanced natural language processing, contextual understanding, and personalized recommendations.</p>
        </div>
      </div>
    </div>
    
    {/* Project Visuals */}
    <h2 style={{color:'#e0aaff',marginBottom:'1rem',marginTop:'2rem'}}>Project Visuals</h2>
    <div style={{display:'flex',flexWrap:'wrap',gap:'2rem',justifyContent:'center',marginTop:'2rem'}}>
      {/* <div style={{background:'#fff2',borderRadius:'1rem',padding:'1.5rem',maxWidth:'320px',textAlign:'center',boxShadow:'0 4px 8px rgba(0,0,0,0.2)'}}>
        <img src="/assets/images/gallery/flowchart.svg" alt="Data Pipeline Visualization" style={{maxWidth:'100%',marginBottom:'1rem',borderRadius:'0.5rem'}} />
        <div style={{color:'#e0aaff',fontWeight:'500',fontSize:'1.1rem'}}>Data Pipeline Visualization</div>
        <p style={{color:'#fff',marginTop:'0.5rem',fontSize:'0.95rem'}}>Architecture diagram showing how data flows through our AI processing pipeline</p>
      </div> */}
      <div style={{background:'#fff2',borderRadius:'1rem',padding:'1.5rem',maxWidth:'320px',textAlign:'center',boxShadow:'0 4px 8px rgba(0,0,0,0.2)'}}>
        <img src={langraphImage} alt="Agent Workflow" style={{maxWidth:'100%',marginBottom:'1rem',borderRadius:'0.5rem'}} />
        <div style={{color:'#e0aaff',fontWeight:'500',fontSize:'1.1rem'}}>Agent Workflow</div>
        <p style={{color:'#fff',marginTop:'0.5rem',fontSize:'0.95rem'}}>Visualization of how our AI agents collaborate to interpret and process user requests</p>
      </div>
      <div style={{background:'#fff2',borderRadius:'1rem',padding:'1.5rem',maxWidth:'320px',textAlign:'center',boxShadow:'0 4px 8px rgba(0,0,0,0.2)'}}>
        <img src={uiImage} alt="User Interface" style={{maxWidth:'100%',marginBottom:'1rem',borderRadius:'0.5rem'}} />
        <div style={{color:'#e0aaff',fontWeight:'500',fontSize:'1.1rem'}}>User Interface</div>
        <p style={{color:'#fff',marginTop:'0.5rem',fontSize:'0.95rem'}}>Screenshot of our intuitive user interface designed for seamless interaction</p>
      </div>
    </div>
    
    <div style={{marginTop:'3rem',textAlign:'center'}}>
      <p style={{color:'#e0aaff',fontSize:'1.1rem'}}>Our demonstrations showcase the perfect balance of technical innovation and practical application.</p>
      <p style={{marginTop:'0.5rem',color:'#fff'}}>Additional screenshots and demos will be added as development continues.</p>
    </div>
  </div>
);

export default Gallery;
